import { CloseIcon } from '../../../assets/icons/Svg'
import Label from '../../ui/Label'
import Input from '../../ui/Input'
import { showToast } from '../../../toastify/Toast';
import { clearTypeModal, clearTypeOfShowModalType, selectCurrentModalType, setTypeOfShowModalType } from '../../../features/modal/modalSlice';
import { useDispatch, useSelector } from 'react-redux';
import Textarea from '../../ui/Textarea';
import { handleApiError } from '../../../utils/handleApiError';
import { useMutationData } from '../../../hooks/api/useMutationData';
import { clearCategory, selectCategorySlice, updateCategory } from '../../../features/category/categorySlice';

export default function CategoryModal() {
    
    const dispatch = useDispatch();
    const typeModal = useSelector(selectCurrentModalType);
    const { createCategory, isLoadingCreateCategory } = useMutationData()
    const categoryForm = useSelector(selectCategorySlice)

    const handleSaveNewCategory = async () => {
        // if (!categoryForm.categoryName) {
        //     showToast("Please fill in all required fields.", "error");
        //     return;
        // }

        const createCategoryForm = {
            categoryName: categoryForm.categoryName,
            description: categoryForm.description,
        };

        try {
            if (typeModal === 'newCategory') {
                await createCategory(createCategoryForm).unwrap();
                showToast("New category has been added.", "success");
            }

            if (typeModal === 'updateCategory') {
                showToast("Category has been updated.", "success");
            }

            dispatch(clearTypeModal());
            dispatch(clearTypeOfShowModalType());
            dispatch(clearCategory());
        } catch (error) {
            handleApiError(error, "Something went wrong. Please try again.");
        }
    };


    const handleCloseCategoryModal = () => {
        dispatch(clearTypeModal());
        if (typeModal === 'newCategory') {
            dispatch(setTypeOfShowModalType('fbTypeModal'));
        } else {
            dispatch(clearTypeOfShowModalType());
        }
    }

    const isDisable: boolean = isLoadingCreateCategory || categoryForm.categoryName.length === 0
    const isLoading: boolean = categoryForm.categoryName.length === 0 || isLoadingCreateCategory

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    {typeModal === 'newCategory' && 'New Category'}
                                    {typeModal === 'updateCategory' && 'Update Category'}
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={handleCloseCategoryModal}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='py-2 space-y-3'>
                            <div className='grid grid-cols-1 gap-3'>
                                <div className=''>
                                    <Label label={'Category Name*'}/>
                                    <Input
                                        type={'text'}
                                        value={categoryForm.categoryName}
                                        onChange={(e) => dispatch(updateCategory({ categoryName: e.target.value }))}
                                        required
                                    />
                                </div>
                            </div>
                            <div className=''>
                                <Label label={'Description *'}/>
                                <Textarea
                                    rowCount={3}
                                    required
                                    value={categoryForm.description}
                                    onChange={(e) => dispatch(updateCategory({ description: e.target.value }))}
                                    placeholder={''}
                                />
                            </div>
                        </div>
                        <button 
                            onClick={handleSaveNewCategory}
                            disabled={isDisable}
                            className={`w-full text-sm px-4 py-2 rounded font-medium transition-all shadow-md
                                ${isLoading ? 'cursor-not-allowed bg-gray-200 border text-black' : 'bg-cbColor text-white'}
                                ${isLoadingCreateCategory ? 'bg-gray-400 cursor-not-allowed' : 'bg-cbColor'}
                            `}
                        >
                            { isLoadingCreateCategory ? ('Saving...') : (
                                <>
                                    {typeModal === 'newCategory' && 'Save Category'}
                                    {typeModal === 'updateCategory' && 'Save Updated Category'}
                                </>
                            )}
                        </button> 
                    </div>
                </div>
            </div>
        </div>
    )
}
